import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Inject, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { L10n, L10nBase } from '@skylab-angular-shared/core';
import { ViewLanguage } from '@skylab-shared/scenes';
import { SelectValueAccessorDirective } from '../value-accessors/select-value-accessor.directive';

export interface LanguageItem<TValue> {
    label: string;
    icon: string;
    symbol: string;
    country: string;
    value: TValue;
}

@Component({
    selector: 'skl-language-picker',
    templateUrl: './language-picker.component.html',
    styleUrls: ['./language-picker.component.scss'],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [SelectValueAccessorDirective, FormsModule]
})
export class LanguagePickerComponent {

    public label!: string;

    @Input() public languages: ViewLanguage[] = [];

    @Input() public language!: ViewLanguage;

    @Output() public languageChange = new EventEmitter<ViewLanguage>();

    public constructor(
        @Inject(L10n) private readonly l10n: L10nBase,
    ) {
        this.label = this.l10n._T('language-picker.language');
    }

    public getImageSrc(imageName: string): string {
        return `/assets/images/${imageName}.svg`;
    }

    public onSelect(): void {
        this.languageChange.emit(this.language);
    }
}
